export const ENDPOINTS = {
  CONTENT: {
    BASE: '/content',
    BANNER: '/content/upskill/banners',
  },
};
